import React from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import Modal from '../modal';
import { MAX_HEIGHT, MAX_WIDTH, MOB_INTEND } from './constants/common';

function TourDialog({ children, className = '' }) {
  return (
    <Modal
      centered
      containerClassName={className}
      width={MAX_WIDTH}
      height={MAX_HEIGHT}
      maxWidth={MAX_WIDTH}
      maxHeight={MAX_HEIGHT}
      fullscreen={bowser.mobile}
      fullscreenIndent={MOB_INTEND}
      overlay="visible"
      draggable={false}
      resizable={false}
    >
      {children}
    </Modal>
  );
}

TourDialog.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
};

export default TourDialog;
